const proposalFiltersInitialValue = { search: '', status: ['all'] };

export { proposalFiltersInitialValue };
